module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "C138"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("EDITOR’S NOTE")])]), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_c('p', {
    staticClass: "C139"
  }, [_c('em', [_vm._v("Form Is Fairy Tale, Fairy Tale Is Form")])])]), _c('p', {
    staticClass: "C140"
  }, [_c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("“All great novels are great fairy tales,” wrote Vladimir Nabokov many years ago, and FAIRY TALE REVIEW continues to believe that all great literary works owe everything to fairy tales. In this issue, as with all previous issues, you will find work represented that draws from the spectacular, old tradition of fairy tales in brilliant new ways. Fairy tales. When I use this phrase, I imagine, you sense in the term a unique form we still recognize and name “fairy tale” even after many centuries of manipulation to its discrete techniques. The form survives these mutations—in stories, novels, poems, essays, music, and art. It is also adaptable to a diverse range of stylistic narrative modes, as evidenced in the wide array of work in this very issue. Fairy tales magnetize writers who identify themselves as realists as much as Surrealists and Dadaists and modernists and fabulists and existentialists, not to mention romance novelists and greeting card authors and tabloid headline writers. Yet in writerly conversations an appreciation of their very classical form is often sublimated to an appreciation of their obvious wild and strange moments. That many writers do celebrate the dark-fantastic cosmos of fairy tales is wonderful, but I would also like to see an increased appreciation for the artistic dexterity and diversity at hand over the centuries. I believe, along with Nabokov and others, that fairy tales work on all of us as authors and readers; they’re so ubiquitious. Yet a critical under-appreciation of the precise art of fairy tales sometimes leads to the misinterpretation of these beautifully deliberate gestures as dream-like, somnolent moments; and (like so much writing associated with women, which fairy tales undeniably are) to fairy-tale writing being considered gem-like and of small importance, unless it reaches a mass-market reader. Instead of looking at how they’ve been disparaged, however, I want to take this tiniest moment to briefly celebrate their form, which resides beautifully in flatness, abstraction, intuitive logic, and normalized magic."), _c('sup')]), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Editor_s_Note#id_3",
      "id": "id_2"
    }
  }, [_vm._v("1")]), _vm._v(" An increased understanding of these precise and incredible fairy-tale techniques, so wonderfully elucidated by one of my heroes, the scholar Max Luthi, but expanded, in the aesthetic of FAIRY TALE "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("REVIEW, to contemporary literature across the styles and genres, may help resolve the unfortunate schisms that sometimes arise between so-called mainstream and avant garde writers and critics. In this issue, as with every issue of FAIRY TALE REVIEW, you will find work across so many such borders; some of the writing refers to specific fairy tales, but much of it simply feels like a fairy tale; and how it feels like a fairy tale is through language, through form. With me please spread the word that fairy tales are the newest and oldest aesthetic; and they give our lives fearful, beautiful shape. Form is fairy tale, fairy tale is form. Here, I seek to give them a magical home.")])]), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_c('p', {
    staticClass: "C141"
  }, [_vm._v("Kate Bernheimer")]), _vm._v(" "), _c('p', {
    staticClass: "C107"
  }, [_vm._v("Tuscaloosa, AL")]), _vm._v(" "), _c('p', {
    staticClass: "C150"
  }, [_vm._v("Note")])]), _c('p', {
    staticClass: "C151n"
  }, [_c('a', {
    attrs: {
      "id": "page_14"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Editor_s_Note#id_2",
      "id": "id_3"
    }
  }, [_vm._v("1")]), _vm._v(". "), _c('em', [_vm._v("A vastly expanded version of this Editor’s Note, with the same title, will appear in")]), _vm._v(" The Writer’s Notebook ("), _c('em', [_vm._v("Tin House Books, 2009")]), _vm._v(").")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07a0be14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/07_Editor_s_Note.vue
// module id = 72
// module chunks = 0